import React from 'react';

export default class NewProblemButton extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="inequality-new-problem">
        <button 
          type="button" className="button button--carrot"
          onClick={this.props.getNewProblemHandler}>
          New Problem
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/new_problem_button.js
 **/